<template>
  <div class="social-share-wrapper">
    <div class="cta-text">
      Teile diese Seite mit deinen Freunden!
    </div>
    <div class="social-share-buttons">
      <a
        :href="whatsappUrl"
        target="_blank"
        rel="noopener"
        title="Teilen auf WhatsApp"
        class="btn btn-whatsapp"
      >
      <font-awesome-icon :icon="['fab', 'whatsapp']" /> &nbsp;WhatsApp
      </a>
      <a
        :href="facebookUrl"
        target="_blank"
        rel="noopener"
        title="Teilen auf Facebook"
        class="btn btn-facebook"
      >
      <font-awesome-icon :icon="['fab', 'facebook']" /> &nbsp;Facebook
      </a>
      <a
        :href="twitterUrl"
        target="_blank"
        rel="noopener"
        title="Teilen auf Twitter"
        class="btn btn-twitter"
      >
      <font-awesome-icon :icon="['fab', 'twitter']" /> &nbsp;Twitter
      </a>
      <a
        :href="threadsUrl"
        target="_blank"
        rel="noopener"
        title="Teilen auf Threads"
        class="btn btn-threads"
      >
      <font-awesome-icon :icon="['fab', 'threads']" /> &nbsp;Threads
      </a>
      <a
        :href="emailUrl"
        title="Teilen per E-Mail"
        class="btn btn-email"
      >
      <font-awesome-icon :icon="['fas', 'envelope']" /> &nbsp;E-Mail
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialShareButtons",
  props: {
    shareText: {
      type: String,
      default: "Empfohlen auf @touriDat"
    }
  },
  computed: {
    pageUrl() {
      // Holt die aktuelle URL
      return window.location.href;
    },
    whatsappUrl() {
      return `https://wa.me/?text=${encodeURIComponent(this.shareText + " " + this.pageUrl)}`;
    },
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.pageUrl)}`;
    },
    twitterUrl() {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareText)}&url=${encodeURIComponent(this.pageUrl)}`;
    },
    threadsUrl() {
      // Threads nutzt X-Share-Dialog (wie Twitter/X)
      return `https://www.threads.net/intent/post?text=${encodeURIComponent(this.shareText + " " + this.pageUrl)}`;
    },
    emailUrl() {
      return `mailto:?subject=${encodeURIComponent(this.shareText)}&body=${encodeURIComponent(this.pageUrl)}`;
    }
  }
};
</script>

<style scoped>
.social-share-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px 0 24px 0;
}
.cta-text {
  font-size: 1.15em;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #222;
}
.social-share-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
.btn {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: #eee;
  text-decoration: none;
  color: #333;
  font-size: 1em;
  transition: background 0.2s;
}
.btn:hover {
  background: #ddd;
}
.btn-whatsapp { color: #25d366; }
.btn-facebook { color: #1877f3; }
.btn-twitter { color: #1da1f2; }
.btn-threads { color: #000; }
.btn-email { color: #ea4335; }
.font-awesome-icon, .fa {
  margin-right: 6px;
}
</style>
